module.exports = __webpack_public_path__ + "media/styles/images/svg/arrow-down-white-3f41d283689cf27bceb813077b303529.svg";